import { FilterCriteriaRow } from "_shared/_views/list-pages/filter-criteria-row";
import {
  columnOf,
  describeColumnFilters,
  type DescribeColumnFilterValue,
} from "_shared/_views/tables/column-filter-description";
import type { MRT_RowData, MRT_TableInstance } from "material-react-table";

/**
 * The column filters a table holds, each a removable chip, with *Clear filters* (#6714), for a list
 * whose URL has no criteria of its own besides them. A page with `WorkRecordCriteriaChips` shows its
 * column filters there instead, in the same row.
 *
 * A chip takes its filter off through the table, so the page's `onColumnFiltersChange` writes the
 * change to the URL as it writes any other.
 *
 * Not memoized: the filters are read from MRT's table instance, one mutable object, so a compiled
 * component sees the same prop on every render and kept the first render's chips.
 */
export function ColumnFilterChips<TData extends MRT_RowData>(
  props: Readonly<{ table: MRT_TableInstance<TData>; describeValue?: DescribeColumnFilterValue }>,
) {
  "use no memo";

  const { table, describeValue } = props;
  const items = describeColumnFilters(table, describeValue).map(({ columnId, text }) => ({
    key: columnId,
    text,
    onRemove: () => columnOf(table, columnId)?.setFilterValue(undefined),
  }));
  return <FilterCriteriaRow items={items} onClearAll={() => table.resetColumnFilters(true)} />;
}
